export const CURRENT_BRANDGEN_ADVERTISER_ID_STORAGE_KEY = "currentBrandgenAdvertiserId";
